module.exports = __webpack_public_path__ + "img/fond_pave_etudiant.17f4479.png";